var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-toolbar',{staticClass:"pl-0 ml-0",attrs:{"short":"","dense":_vm.$vuetify.breakpoint.smAndDown,"flat":""}},[_vm._t("default"),_vm._t("buttons.prepend"),_vm._t("buttons.append")],2),_c('v-divider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }